import { post, get } from './requests'

export const emailInvite = (key, payload) => post(['email-invite'], { key }, payload)

export const myReferrals = key => get(['my-referrals'], { key, transformPayload: true })
